import { useEffect, useSyncExternalStore } from 'react';

const KEY = 'cls_theme';

function getTheme(): 'light' | 'dark' {
  if (typeof window === 'undefined') return 'dark';
  const v = localStorage.getItem(KEY);
  if (v === 'light' || v === 'dark') return v;
  return 'dark';
}

const listeners = new Set<() => void>();

function subscribe(cb: () => void) {
  listeners.add(cb);
  return () => listeners.delete(cb);
}

function notify() {
  listeners.forEach((l) => l());
}

export function useTheme(): { theme: 'light' | 'dark'; toggle: () => void } {
  const theme = useSyncExternalStore(subscribe, getTheme, () => 'dark' as const);

  useEffect(() => {
    const body = document.body;
    if (theme === 'light') body.classList.add('light-mode');
    else body.classList.remove('light-mode');
  }, [theme]);

  const toggle = () => {
    const next = theme === 'dark' ? 'light' : 'dark';
    localStorage.setItem(KEY, next);
    notify();
  };

  return { theme, toggle };
}
